<!--
 * 严肃声明：
 * 开源版本请务必保留此注释头信息，若删除我方将保留所有法律责任追究！
 * 本系统已申请软件著作权，受国家版权局知识产权以及国家计算机软件著作权保护！
 * 可正常分享和学习源码，不得用于违法犯罪活动，违者必究！
 * Copyright (c) 2020 陈尼克 all rights reserved.
 * 版权所有，侵权必究！
 *
-->
<template>
  <div class="router-view">
      <router-view v-slot="{ Component }">      
        <transition appear :name="transitionName">
          <keep-alive :include="includeList">
            <component :is="Component" />
          </keep-alive>
        </transition>
      </router-view>
      
      <router-link to="/index" class="goHome" v-if="canGoBack">
        <img class="img" src="./assets/images/goHome.png" alt="" />
      </router-link>
    </div>
</template>

<script>
import { reactive, onMounted,watch, toRefs, nextTick } from 'vue'
import { mapGetters } from 'vuex'
import { getWechatConfig } from "@/api/login";
import { Toast } from 'vant'; 
import { useRoute,useRouter } from 'vue-router'
import store from '@/store'
import { wechatConfig } from "@/utils/wechatSdk";
 import { getToken } from '@/utils/auth'
import { urlencode, getUrlParam } from "@/utils/index";
import wx from "weixin-js-sdk"
var toast1;
export default {
  name:'App',
  computed: {
    ...mapGetters([
      'enrollState' //注册状态 100未查询  0: 未提交审核 1：资料已提交 2：已经人脸核身（审核中） 3：审核通过 4：审核失败
    ])
  },
  setup() {
    const router = useRouter();
    const route = useRoute();

    const state = reactive({
      appId: 'wxad104e066a4e583a',  //公众号appId
      platform: '',     //平台  微信WX 支付宝ZFB 闪付扫码=YSF
      code: '',           //公众号code

      transitionName: '',
      canGoBack:false,
    })   

    router.beforeEach(async (to, from,next) => {
      /* 路由发生变化修改页面title */
      if (to.meta.title) {  
        document.title = to.meta.title
      }
      // 而不是去检查每条路由记录
      // to.matched.some(record => record.meta.requiresAuth)
      if (to.meta.requiresAuth) {
        IsWeixinOrAlipay();  //判断扫码APP客户端 
        if(!store.getters['token']){
          // 此路由需要授权，请检查是否已登录
          // 如果没有，则重定向到登录页面
          next({
            path: '/login',
            query: { redirect: to.fullPath}, // 保存我们所在的位置，以便以后再来
          })
          return;
        }

        if(store.getters['enrollState']==100){
          await store.dispatch('QueryUserIsBind');
        }
        let fullPath=to.fullPath;
        if(to.meta.roles && to.meta.roles.length>0 && to.meta.roles.indexOf(store.getters['role'])<0){
          fullPath=""
        }
        //支付人不用注册，授权登录后返回支付。
       
        if(store.getters['enrollState'] ==0 && to.fullPath.indexOf('/register')==-1 && fullPath.indexOf('/orderpay')==-1){
           next({
            path: '/register',
            query: { redirect:fullPath},
          })
          return;
        }
        if(!fullPath){
          next({
            path: '/',
          })
          return
        }
       
      }   
      
      next();
    })

    //显示返回
    router.afterEach((to,from)=>{
      if(window.history.length>1 || !to.meta || to.meta.hideHome){
        state.canGoBack=false;
      }else{
       state.canGoBack=true;
      }
    })




    onMounted(async () => {   
     // 8899  默认登录
      // store.dispatch('debugData').then(res => {              
      // }).catch(() => {
      // })

      sessionStorage.setItem('EntryUrl',window.location.href.split('#')[0])
      
      if(store.getters['token'] && store.getters['enrollState']!=100){

        fnQueryUserIsBind();//查询是否注册 
      }else{
        nextTick(() => {
          setTimeout(function(){
            getWxJssdkConf();  //获取微信sdk配置
          },3000)
        })
      }

    })

    //判断扫码APP客户端，是否为微信、支付宝
    const IsWeixinOrAlipay = () => {
      var ua = window.navigator.userAgent.toLowerCase();
      console.log(ua)
      //判断是不是微信
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        state.platform = "WX";          
      }
      if(state.platform != "WX"){
        // toast1.clear();
        //哪个都不是
        router.push({
          path: "/unableplat",
          replace: true
        })
      }
    }
    //查询是否注册
    const fnQueryUserIsBind = () => {
      store.dispatch('QueryUserIsBind').then(res => {
        if(res.code == 401||res.code === 403){
          //重新登录
          if(router.currentRoute._value.meta.requiresAuth == true){
            router.push({
              path: '/login',
              // 保存我们所在的位置，以便以后再来
              query: { redirect: router.currentRoute._value.fullPath },
              replace: true
            })
          }
        }else{
          // console.log(res)          
          // 需要刷新页面，否则 axios.js 文件里的 token 不会被重置          
          nextTick(() => {
            setTimeout(function(){
              getWxJssdkConf();  //获取微信sdk配置
            },3000)
          })
        }
      }).catch((err) => {
        //重新登录
        if(router.currentRoute._value.meta.requiresAuth == true){
          router.push({
            path: '/login',
            // 保存我们所在的位置，以便以后再来
            query: { redirect: router.currentRoute._value.fullPath },
            replace: true
          })
        }    
      })
    }
    //微信配置
    const getWxJssdkConf = () => {    
      // 在调用SDK时，通过URL获取签名
      let url = '';
      if (navigator.userAgent.indexOf('iPhone') !== -1) {
        // IOS 记录微信菜单打开时的url
        // getItemByEntryUrl()方法 是拿到之前存在storage中的URL
        url = sessionStorage.getItem('EntryUrl');
      } else {
        // 安卓 记录当前使用SDK的页面的url
        const { href } = window.location;
        url = href.split('#')[0];
      }  

      // let url = encodeURIComponent(location.href.split('#')[0]);
      // Toast(location.href.split('#')[0]);
      getWechatConfig(encodeURIComponent(url)).then((res) => {
        // sessionStorage.removeItem('EntryUrl');
        if (res.code == 200) {
          const config = {
            debug: false,// // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.data.appId, // 必填，公众号的唯一标识
            timestamp: res.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
            signature: res.data.signature, // 必填，签名
            jsApiList: ["updateAppMessageShareData", 'checkJsApi',"hideMenuItems"], // 必填，需要使用的JS接口列表，注意查看官方文档，部分js接口即将废弃，我这里用的是新的
            openTagList: ["wx-open-launch-weapp"], // 可选，需要使用的开放标签列表（当前标签用于跳转微信小程序）
          };
          // console.log(wx)
          wx.config(config); //通过config接口注入权限验证配置
          wx.ready(function () { //通过ready接口处理成功验证
            wx.checkJsApi({
              jsApiList: ["updateAppMessageShareData", 'checkJsApi'],
              success (res) {
                console.log('微信配置', res);
              }
            });  
            //隐藏
            wx.hideMenuItems({
              menuList: [
              'menuItem:share:timeline',   // 分享到朋友圈
              'menuItem:openWithQQBrowser',
              'menuItem:openWithSafari',
            ]
          });
            wechatConfig(
              "雅丽洁支付",
            ).then((res) => {});
            
          });
          wx.error((res) => {
            alert(`出错了：${res.errMsg}`);// 这个地方的好处就是wx.config配置错误，会弹出窗口哪里错误，然		后根据微信文档查询即可。
          });
        }
      });
    }


    return {
      ...toRefs(state),
      includeList: ['orderflow', 'ordersearch', 'index']
    }
  }
}
window.onload = function() {
  document.addEventListener('touchstart', function(event) {
      if (event.touches.length > 1) {
          event.preventDefault()
      }
  })
  document.addEventListener('gesturestart', function(event) {
      event.preventDefault()
  })
}
</script>

<style lang="less">
html, body {
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  background-color: #f2f2f2;
}
#app {
  height: 100%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* // text-align: center; */
  color: #2c3e50;
  -webkit-overflow-scrolling: touch;
}

.router-view{
    width: 100%;
    height: auto;
    margin: 0 auto;
    position: absolute;
    top: 0;
    bottom: 0;
    -webkit-overflow-scrolling: touch;
 
}
.page-content{
  max-width: 500px;
  margin: auto;
}



.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active{
    /* width: 100%; */
    height: 100%;
    will-change: transform;
    transition: all 500ms;
    position: absolute;
    backface-visibility: hidden;
}
.slide-right-enter{
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
}
.slide-right-leave-active{
    opacity: 0;
    transform: translate3d(100%, 0, 0);
}
.slide-left-enter{
    opacity: 0;
    transform: translate3d(100%, 0, 0);
}
.slide-left-leave-active{
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
}

.van-badge--fixed {
  z-index: 1000;
}

.goHome{
  position: fixed;
  right: 20px;
  bottom: 10%;
  padding: 12px;
  background-color: #999;
  border-radius: 50px;
  .img{
    width: 24px;height: 24px;
    display: block;
  }
}

</style>
